const findContentById = (element, targetId) => {
  // Base case: check if the current element has the desired id
  if (element && element.props && element.props.id === targetId) {
    return element.props.children;
  }

  // If element has children, recursively search in each child
  if (element && element.props && element.props.children) {
    // If children is an array, iterate through it
    if (Array.isArray(element.props.children)) {
      for (const child of element.props.children) {
        const result = findContentById(child, targetId);
        if (result) return result; // If found, return immediately
      }
    } else {
      // If children is a single object, continue recursion
      return findContentById(element.props.children, targetId);
    }
  }

  // Return null if the target id is not found in the structure
  return null;
};

export default findContentById;